<div class="space-y-6">
  <!-- Create/Update Feature Form -->
  <div
    class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 backdrop-blur-xl animate-in slide-in-from-top-4 duration-500">
    <h2 class="text-xl font-bold bg-gradient-to-r from-violet-400 to-indigo-500 bg-clip-text text-transparent mb-6">
      {{ isEditMode() ? 'Updating' : 'New' }} Feature Configuration
    </h2>

    <div class="grid grid-cols-12 gap-4 md:gap-6 items-end">
      <div class="col-span-12 sm:col-span-6 lg:col-span-3">
        <app-input label="Public Name" [(ngModel)]="currentFeature.name" placeholder="E.g., Call Auditor" [fullWidth]="true"
          variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-3">
        <app-input label="Unique Keyname" [(ngModel)]="currentFeature.keyname" placeholder="E.g., call_auditor"
          [fullWidth]="true" variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-6 lg:col-span-3">
        <app-input label="Description" [(ngModel)]="currentFeature.description"
          placeholder="Brief context of this feature" [fullWidth]="true" variant="themeBase" size="lg" />
      </div>
      <div class="col-span-12 sm:col-span-12 lg:col-span-3 flex gap-2">
        <div class="flex-1">
          <app-button [variant]="isEditMode() ? 'secondary' : 'primary'" (buttonClick)="saveFeature()"
            [disabled]="!currentFeature.name || !currentFeature.keyname" className="w-full !h-12 whitespace-nowrap">
            {{ isEditMode() ? 'Update Changes' : 'Create' }}
          </app-button>
        </div>
        @if (isEditMode()) {
        <app-button variant="secondary" (buttonClick)="resetForm()"
          className="bg-slate-200 dark:bg-slate-700 !h-12 w-12 p-0 flex items-center justify-center shrink-0">
          <app-icon name="x" [size]="18"></app-icon>
        </app-button>
        }
      </div>
    </div>
  </div>

  <!-- Feature Library Table -->
  <div class="card-bg rounded-2xl p-6 border border-slate-200 dark:border-white/5 animate-in fade-in duration-700">
    <div class="flex flex-wrap items-center justify-between gap-4 mb-6">
      <h3 class="text-lg font-semibold text-slate-800 dark:text-slate-200">System Feature Library</h3>
      <span
        class="px-3 py-1 bg-emerald-100 text-emerald-600 dark:bg-emerald-900/30 dark:text-emerald-400 rounded-full text-xs font-medium">
        Active Master Records
      </span>
    </div>

    <app-paginated-table [headers]="headers" [tableData]="features()" [isCheckboxShow]="false"
      [tableActionOptions]="{ showToggleButton: true, toggleOptions: actionOptions }"
      (actionSelected)="handleAction($event)" [tableWrapperClass]="'!h-auto !overflow-x-auto !bg-transparent !backdrop-blur-none !shadow-none !border-none'"/>
  </div>

  @if (successMessage()) {
  <app-alert [message]="successMessage()" type="success" [duration]="3000" (close)="successMessage.set('')" />
  }
</div>